import { render } from "./App.vue?vue&type=template&id=66ca4043"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=66ca4043&lang=css"
script.render = render

export default script